import { SmartList } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const smartListConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): SmartList =>
    firebaseObjectTimestampToDate(snapshot.data()) as SmartList,
  toFirestore: (smartList: SmartList) => smartList,
};
